import localStorageSupport from 'helpers/localStorageSupport';

const defaults = {
  cookieIDAttr: 'data-language-notice-cookie-id',
  closeButtonSelector: '[data-language-notice-hide]'
};

class LanguageNotice {

  constructor (element, settings) {
    this.languageNotice = element;
    this.options = Object.assign({}, defaults, settings);
    this.languageNoticeClose = element.querySelectorAll(this.options.closeButtonSelector);
    this.cookieID = element.getAttribute(this.options.cookieIDAttr);
    this.clickListener = this.clickEvent.bind(this);
  }

  addEventListeners () {
    if (this.languageNoticeClose) {
      [...this.languageNoticeClose].map(item => {
        item.addEventListener('click', this.clickListener, false);
      });
    }
  }

  removeEventListeners () {
    if (this.languageNoticeClose) {
      this.languageNoticeClose.removeEventListener('click', this.clickListener, false);
    }
  }

  removeLanguageNotice () {
    this.languageNotice.parentNode.removeChild(this.languageNotice);
  }

  showLanguageNotice () {
    this.languageNotice.classList.remove('is-hidden');
    this.languageNotice.setAttribute('aria-hidden', false);
  }

  hideLanguageNotice () {
    this.languageNotice.classList.add('is-hidden');
    this.languageNotice.setAttribute('aria-hidden', true);
  }

  initLanguageNotice () {
    this.languageNotice.classList.add('is-initialized');
  }

  clickEvent (e) {
    e.preventDefault();
    if (this.cookieID) {
      this.setCookieValue(this.cookieID);
    }
    if (e.target.hasAttribute('href')) {
      window.location.href = e.target.getAttribute('href');
    } else {
      this.hideLanguageNotice();
      setTimeout(() => this.removeLanguageNotice(), 1000);
    }
  }

  removeAllAttrs () {
    this.languageNoticeClose.removeAttribute('aria-hidden');
  }

  removeAllClasses () {
    this.languageNotice.classList.remove('is-hidden');
    this.languageNotice.classList.remove('is-initialized');
  }

  setCookieValue (id) {
    if (localStorageSupport && window.JSON !== 'undefined') {
      return window.localStorage.setItem(id, JSON.stringify({ suppressed: true }));
    }
  }

  getCookieValue (id) {
    if (localStorageSupport && window.JSON !== 'undefined') {
      return window.localStorage.getItem(id);
    }
  }

  testForHideOnLoad () {
    if (this.getCookieValue(this.cookieID)) {
      this.removeLanguageNotice();
    } else {
      this.initLanguageNotice();
    }
  }

  init () {
    this.addEventListeners();
    if (this.cookieID) {
      this.testForHideOnLoad();
    } else {
      this.initLanguageNotice();
    }
  }

  destroy () {
    this.removeAllAttrs();
    this.removeAllClasses();
    this.removeEventListeners();
  }
}

export default LanguageNotice;
